import { useEffect, useState } from "react"

import { useNavigate } from "react-router-dom"
import { useMediaContext } from "context/MediaContext"

import { getAuth, signInWithPopup, TwitterAuthProvider } from "firebase/auth"
import { Alert, Button, Box, CardMedia, Container, Link, Typography, Dialog } from "@mui/material"
import PrivacyPolicy from "component/Legal/PrivacyPolicy"

import { Twitter } from "@mui/icons-material"
import header from '../../asset/headicon.png'

import * as userRepository from 'repository/UserRepository'

export default function AuthByTwitter() {
  const navigate = useNavigate()
  const { isPc } = useMediaContext()
  const [isDisplayDialog, setIsDisplayDialog] = useState(false)

  const auth = getAuth()
  useEffect(() => {
    if (auth.currentUser) navigate('/')
  },[])
  
  const provider = new TwitterAuthProvider()
  const [success, setSuccess] = useState('')
  const [error, setError] = useState('')
  async function handleTwitterAuth() {
    setError('')
    try {
      const result = await signInWithPopup(auth, provider)
      setSuccess('認証に成功しました。マイページにリダイレクトします。')

      try {
        await userRepository.findFromCache(result.user.uid)
        navigate(`/mypage?id=${result.user.uid}`)
      } catch (error: any) {
        const user = {
          uuid: result.user.uid,
          name: result.user.displayName!,
          rate: 1500,
          open_game_history: true,
          open_winrate_by_decktype: true,
          open_rate_transition: true
        }
        try {
          await userRepository.save(user)
          navigate(`/mypage?id=${result.user.uid}`)
        } catch (error: any) {
          setError('ユーザー登録に失敗しました。管理者にお問い合わせください。')
        }
      }
    } catch (error: any) {
      switch (error.code) {
        case 'auth/user-cancelled':
          setError('認証がキャンセルされました。')
          break;
        default:
          setError('認証に失敗しました。通信環境が良い所で再度やり直してください。')
      }
    }
  }

  return (
    <>
      <Container maxWidth='xs' sx={{mt: 2}}>
        <CardMedia
          component='img'
          src={header}
          sx={{mb: 5}}
        />

        <Box sx={{
          display: 'flex',
          flexDirection: 'column',
          px: 2
        }}>
          {success &&
            <Alert variant='outlined' severity='info' sx={{ mb: 2 }}>{success}</Alert>
          }
          {error &&
            <Alert variant='outlined' severity='error' sx={{mb: 2}}>{error}</Alert>
          }
          <Typography variant='h6'>Twitter認証</Typography>
          <Typography variant='body2' color='text.secondary'>
            『Rating for MasterDuel』をご利用頂きありがとうございます。
          </Typography>
          <Typography variant='body2' color='text.secondary'>
            まずはTwitter認証によるユーザー登録をお願いします。
          </Typography>
          <Button
            variant='outlined'
            size='large'
            fullWidth
            startIcon={<Twitter />}
            onClick={handleTwitterAuth}
            sx={{mt: 2}}
          >
            認証する
          </Button>
          <Link variant='body2' sx={{ mt: 3, cursor: 'pointer' }} onClick={() => setIsDisplayDialog(true)}>
            プライバシーポリシー
          </Link>
          <Link variant='body2' sx={{ mt: 2 }} href='https://twitter.com/signup' target='_blank'>
            Twitterアカウントをお持ちでない方
          </Link>
        </Box>
      </Container>
      <Dialog open={isDisplayDialog}>
        <Box sx={isPc ? { px: 10, py: 3 } : {px: 3, py: 1}}>
          <PrivacyPolicy />
          <Button
            variant='outlined'
            color='inherit'
            sx={{ display: 'block', m: 'auto', mt: 2 }}
            onClick={() => setIsDisplayDialog(false)}
          >
            閉じる
          </Button>
        </Box>
      </Dialog>
    </>
  )
}